<template>
  <div @mousedown="handleMouseDown()" @mouseup="handleMouseUp()" :style="buttonStyle" :class="[roundClass, activeClass]" class="ButtonIcon lxn-cursor-pointer">
    <div v-html="svgIcon" class="ButtonIcon-d0 lxn-w100 lxn-h100">
    </div>
  </div>
</template>

<script>
import svgIcons from '@/statics/svgIcons.js'

export default {
  name: 'ButtonIcon',
  props: {
    size: Number,
    bgColor: String,
    icon: String,
    iconColor: String,
    padding: Number,
    isRound: Boolean,
    borderWidth: Number,
    borderColor: String,
    onclickEffect: Boolean,
  },
  data: function() {
    return {
      activeClass: '',
    }
  },
  computed: {
    buttonStyle: function() {
      var buttonStyle = '';
      buttonStyle += "width: " + this.size + "px;";
      buttonStyle += "height: " + this.size + "px;";
      buttonStyle += "background-color: " + this.bgColor + ";";
      buttonStyle += "fill: " + this.iconColor + ";";
      buttonStyle += "padding: " + this.padding + "px;";
      if(this.borderWidth){
        buttonStyle += "border-style: solid;";
        buttonStyle += "border-width: " + this.borderWidth + "px;";
        buttonStyle += "border-color: " + this.borderColor + ";";
      }
      return buttonStyle;
    },
    roundClass: function() {
      return this.isRound ? 'lxn-circle' : 'lxn-border-round';
    },
    svgIcon: function() {
      return svgIcons[this.icon];
    },
  },
  methods: {
    handleMouseDown: function () {
      if(this.onclickEffect){
        this.activeClass = 'active';
      }
    },
    handleMouseUp: function () {
      if(this.onclickEffect){
        this.activeClass = '';
      }
      this.$emit('click');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .ButtonIcon {
    transition: 100ms all linear;
  }
  .ButtonIcon.active {
    opacity: 0.6;
  }
  .ButtonIcon-d0 {
    line-height: 0;
  }
</style>
